import LogoFooter from '@elotech/arc/src/assets/img/common/logo-footer.svg';
import { usePreviousState } from '@elotech/components';
import axios from 'axios';
import AuthService from 'common/auth/AuthService';
import keycloakService from 'keycloak/KeycloakService';
import { useEffect, useState } from 'react';
import { connect } from 'react-redux';

import Areas from './areas/Areas';

const agruparModulos = modulos => {
  return modulos.reduce((result, current) => {
    if (result[current.area]) {
      result[current.area].modulos = [...result[current.area].modulos, current];
    } else {
      result[current.area] = {
        descricao: current.descricaoArea,
        modulos: [current]
      };
    }
    return result;
  }, {});
};

const defaultModuloResolver = () => {
  return axios
    .get(`${keycloakService.getUrl()}/usuario/me/modulos`, {
      headers: {
        Authorization: `Bearer ${keycloakService.getToken()}`,
        'x-tenant-host': window.location.host
      }
    })
    .then(response => response.data);
};

const agruparIdentificadores = agrupados =>
  Object.keys(agrupados).reduce((result, current) => {
    result[current] = true;
    return result;
  }, {});

const OffSidebarModulo = ({ getModulos = defaultModuloResolver, ui }) => {
  const [modulosAgrupados, setModulosAgrupados] = useState({});
  const [areasExpandidas, setAreasExpandidas] = usePreviousState({});

  useEffect(() => {
    if (AuthService.isLogged() || keycloakService.isLogged()) {
      getModulos().then(response => {
        const agrupados = agruparModulos(response);
        setAreasExpandidas(agruparIdentificadores(agrupados));
        return setModulosAgrupados(agrupados);
      });
    }

    //eslint-disable-next-line
  }, [getModulos]);

  const handleExpand = area => {
    setAreasExpandidas(oldAreas => ({
      ...oldAreas,
      [area]: !oldAreas[area]
    }));
  };

  return (
    <div
      className={`features-modules ${
        ui.offsidebarModuloToggled ? 'active' : ''
      }`}
    >
      <h2 className="title">Módulos</h2>
      <ul className="tab">
        <li className="active">
          <div className="features-body">
            <Areas
              areas={modulosAgrupados}
              onExpand={handleExpand}
              areasExpandidas={areasExpandidas}
            />
          </div>
        </li>
      </ul>
      <div className="footer-oxy-logo hidden-sm hidden-xs">
        <img src={LogoFooter} alt="Logo" />
      </div>
    </div>
  );
};

const mapStateToProps = state => ({
  ui: state.ui
});

const connectedComponent = connect(mapStateToProps)(OffSidebarModulo);

export default connectedComponent;
